module.exports = __webpack_public_path__ + "img/cjc1_style_5_font_sprite.dfd47660.webp";